import { render } from "./DataKeluarga.vue?vue&type=template&id=3be2b361"
import script from "./DataKeluarga.vue?vue&type=script&lang=js"
export * from "./DataKeluarga.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__